export default __webpack_public_path__ + "f30caabd53c43e53c942a29ff4a4f8ab.svg";